import React, { PureComponent } from 'react'
import { View, Platform } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'

import Radio from '../../Atoms/Radio'

import theme from '../../../styles/theme'

const Row = styled(View)`
  flex: 1;
  flex-direction: row;
  align-items: center;
`

const Item = styled(View)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 9%;
  padding: ${theme.gutterUnit}px;
  justify-content: flex-start;
  height: 140px;
`

const TextWrapper = styled(View)`
  padding: ${theme.gutterUnit}px 0;
`

export default class Rating extends PureComponent {
  render () {
    const { rating, onChangeRating } = this.props
    const ratings = Array.from(Array(11)).map((_, i) => ({
      value: i,
      selected: rating === i
    }))
    return (
      <Row>
        {ratings.map(r => (
          <Item key={r.value}>
            <TextWrapper>
              <Text center>{r.value === 0 ? 'N/A' : r.value}</Text>
            </TextWrapper>
            <Radio isChecked={r.selected} onClick={e => onChangeRating({ ...e, value: r.value })} style={{ paddingBottom: Platform.select({ web: 3 * theme.gutterUnit, default: 0 }) }} />
            <TextWrapper style={{ height: 60 }}>
              {r.value === 1 && (
                <Text center size='s'>
                  Strongly{'\n'}Disagree
                </Text>
              )}
              {r.value === 10 && (
                <Text center size='s'>
                  Strongly{'\n'}Agree
                </Text>
              )}
            </TextWrapper>
          </Item>
        ))}
      </Row>
    )
  }
}
